import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/settings.svg'
import _imports_1 from '../assets/edit.svg'
import _imports_2 from '../assets/search.svg'
import _imports_3 from '../../globalModule/assets/paper-plane.svg'


const _withScopeId = n => (_pushScopeId("data-v-78be1e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading" }, "Project Manager", -1))
const _hoisted_8 = { class: "icon-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "subtitle-margin" }, " Create your own project or start with a template ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "centre" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "heading" }, "Project Manager"),
  /*#__PURE__*/_createElementVNode("h3", null, "Search project by keywords")
], -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "project-list" }
const _hoisted_17 = { class: "project-square" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create your Own Project", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-dotted-line" }, null, -1))
const _hoisted_21 = { class: "project-list" }
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchWImage = _resolveComponent("SearchWImage")!
  const _component_fa = _resolveComponent("fa")!
  const _component_SavedWorkspace = _resolveComponent("SavedWorkspace")!
  const _component_ProjectTemplateVue = _resolveComponent("ProjectTemplateVue")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.settings()))
          }, _hoisted_4),
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editProjects()))
          }, _hoisted_6)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "icon-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchProjects()))
          }, _hoisted_10),
          _createElementVNode("a", {
            class: "icon-button",
            target: "_blank",
            title: "Switch to Edu Demo",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/edu')))
          }, _hoisted_12)
        ])
      ]),
      _hoisted_13,
      (_ctx.projectSearchVisible)
        ? (_openBlock(), _createBlock(_component_SearchWImage, {
            key: 0,
            onOnExit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchProjects())),
            onOnInputChange: _cache[5] || (_cache[5] = (e) => _ctx.onSearchInput(e))
          }, {
            header: _withCtx(() => [
              _hoisted_14
            ]),
            items: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.workspacesInfo.info).filter(([_, ea]: [string, any]) => 
            ea.name.toLowerCase().includes(_ctx.projectSearchText.toLowerCase())), ([id, project]) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: "project-display",
                  onClick: ($event: any) => (_ctx.openWorkspace(id)),
                  key: id
                }, _toDisplayString((project as any).name), 9, _hoisted_15))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, [
          _createElementVNode("button", {
            class: "project-square-button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createNewProject()))
          }, [
            _createVNode(_component_fa, { icon: "plus" })
          ]),
          _hoisted_18
        ]),
        (!_ctx.workspacesInfo.isSet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "...Loading"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspacesInfo.info
          ? Object.keys(_ctx.workspacesInfo?.info)
          : [], (workspaceId) => {
          return (_openBlock(), _createBlock(_component_SavedWorkspace, {
            id: workspaceId,
            name: _ctx.workspacesInfo.info[workspaceId]?.name,
            "is-edit": _ctx.projectOptionsVisible,
            key: workspaceId,
            onDeleteProject: _ctx.deleteProject,
            canCreate: _ctx.canCreate
          }, null, 8, ["id", "name", "is-edit", "onDeleteProject", "canCreate"]))
        }), 128))
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        (!_ctx.workspacesInfo.isSet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, "...Loading"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pmStore.templates, (template) => {
          return (_openBlock(), _createBlock(_component_ProjectTemplateVue, {
            projectName: template.name,
            image: template.image,
            id: template.id,
            key: template.id
          }, null, 8, ["projectName", "image", "id"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Dialog)
  ], 64))
}